import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  filter,
  take,
  takeUntil,
} from 'rxjs';
import { SaleConsignorModel } from 'src/app/models/sales/sale-consignor.model';
import { SaleHorseNoteModel } from 'src/app/models/sales/sale-horse-note.model';
import { SaleVetModel } from 'src/app/models/sales/sale-vet.model';
import {
  Sale,
  SaleSubmissions,
  SaleSubmissionsStatusIds,
} from 'src/app/models/sales/sales.model';
import { HttpErrorHandlerService } from 'src/app/services/http-error-handler.service';
import { SalesService } from 'src/app/services/sales.service';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { SalesFacade } from 'src/app/shared-new/store/sales/sales.facade';
import { StudiesFacade } from 'src/app/shared-new/store/studies/studies.facade';
import { SaleHorse, SaleHorseStatus } from '../../models/sales/sale-horse.model';
import {
  SaleMemberRequests,
  SaleMembersStatusIds,
} from '../../models/sales/sale-member-request.model';
import { AuthService } from '../../services/auth.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { EventsEmitter } from '../../shared/event-emitter/EventEmitter';
import { Helper } from '../../utils/helper/helper';
import { SaleHorseStatusModalComponent } from '../sale-horse-status-modal/sale-horse-status-modal.component';
import { SaleSendEmailSmsPopupComponent } from '../sale-send-email-sms-popup/sale-send-email-sms-popup.component';
import { SaleStudyFilesPopupComponent } from '../sale-study-files-popup/sale-study-files-popup.component';
import { LookupModel } from '../../models/common/lookup.model';
import { MailService } from '../../shared-new/services/mail.service';
import { NotificationType } from '../../shared-new/enums/notification-type.enum';
import { CommonService } from 'src/app/services/common.service';
import { SaleSettingModel } from '../../models/sales/sale-settings.model';
import { SaleHorseRepoContactDto } from '../../models/sales/sale-contacts.model';
import { SaleHorseRepoContactEditComponent } from '../sale-horse-repo-contact-edit/sale-horse-repo-contact-edit.component';
import { RepoBusinessService } from '../../shared-new/services/repo-business.service';
import Swal from 'sweetalert2';
import { NotificationAction, NotificationEvent, SaleRequestNotificationDto, StudySubmittedNotificationDto } from '../../models/common/notification-event.model';
@Component({
  selector: 'app-sale-profile',
  templateUrl: './sale-profile.component.html',
  styleUrls: ['./sale-profile.component.scss'],
  providers: [Helper],
})
export class SaleProfileComponent
  extends BaseUnsubscribeComponent
  implements OnInit, OnDestroy, AfterViewInit {
  public sale: Sale = null;
  public saleStatuses: LookupModel[] = null;
  public saleHorseNoteModel: SaleHorseNoteModel = null;
  public searchTerm: string;
  public saleId: number;
  public tab: string = 'horses';

  public saleConsignors: SaleConsignorModel[] = null;
  public allSalesConsignors: SaleConsignorModel[] = null;
  public allSalesConsignorsCount = 0;
  public isLoaderSaleConsignors: boolean = false;
  public allCountries: any[] = [];
  public saleVets: SaleVetModel[] = null;
  public contacts: SaleHorseRepoContactDto[] = null;
  public allSalesVets: SaleVetModel[] = null;
  public salesVetsCount = 0;
  public contactsCount = 0;
  public isLoaderSaleVets: boolean = true;
  public selectedVets: any[] =[];
  public closeResult = '';
  public saleSetting: SaleSettingModel;

  public saleMemberRequests: SaleMemberRequests[] = null;
  public allSaleMemberRequests: SaleMemberRequests[] = null;
  public saleMemberRequestCount = 0;
  public submissionId = 0;
  public isLoaderSaleMemberRequest: boolean = true;

  public isUserSaleEditor: boolean;

  public isSaleLoading: boolean;

  public formDataEmailConsignors: { consignorId: number; shareLink: string }[] =
    [];

  public saleSubmissions: SaleSubmissions[] = null;
  public allSaleSubmissions: SaleSubmissions[] = null;
  public saleSubmissionsCount: string = '';
  public isLoaderSaleSubmissions = false;
  public books: number[];
  public sessions: number[];
  public lotOrHipText: string;
  saleProfileError$ = this.saleFacade.saleProfileError$;
  saleHorsesLoaded$ = this.saleFacade.saleHorsesLoaded$;
  sales$ = this.saleFacade.sales$;

  saleStatusesLoaded$ = this.saleFacade.saleStatusesLoaded$;
  saleStatuses$ = this.saleFacade.saleStatuses$;
  salesLoaded$ = this.saleFacade.salesLoaded$;
  saleHorse$ = this.saleFacade.selectSaleHorse$;
  filterForm: FormGroup;
/*  @ViewChild('searchInput') public readonly searchInput: ElementRef;*/
  saleHorses: SaleHorse[];
  updateSaleHorses: SaleHorseStatus[];
  allSaleHorses: SaleHorse[];
  saleHorse: SaleHorse;
  @ViewChild(SaleSendEmailSmsPopupComponent, { static: false })
  private emailModal: SaleSendEmailSmsPopupComponent;
  isSalesCompany = this.authService.IsSalesCompany();
  constructor(
    public readonly authService: AuthService,
    private readonly salesService: SalesService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly modalService: NgbModal,
    private readonly helper: Helper,
    private saleFacade: SalesFacade,
    private readonly commonService: CommonService,
    private readonly route: Router,
    private formBuilder: FormBuilder,
    private studyFacade: StudiesFacade,
    private toastService: ToastService,
    private router: Router,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private readonly eventEmitter: EventsEmitter,
    private readonly mailService: MailService,
    private readonly repoBusinessService: RepoBusinessService
  ) {
    super();
  }

  public async ngOnInit() {

    if (this.authService.IsVet()) {
      this.tab = "horses";
    }

    this.filterForm = this.formBuilder.group({
      book: [''],
      session: [''],
      consignor: [''],
      sire: [''],
      dam: [''],
      vet: [''],
      xray: [''],
      scope: [''],
      report: [''],
      // Add more form controls as needed
    });
    this.saleId = Number(this.activatedRoute.snapshot.paramMap.get('id'));
    //const token = this.authService.getToken();
    //if (this.salesSignalRService.isConnected()) {
    //  this.salesSignalRService.joinSale(this.saleId);
    //}
    this.eventEmitter.onStudySubmitted.pipe(takeUntil(this.unsubscribe$)).subscribe((notification: NotificationEvent<StudySubmittedNotificationDto>) => {
      if (this.saleId === notification.scope.saleId) { 
        if (notification.action === NotificationAction.Submitted) { // only for sales companies
          this.loadVets(this.saleId, true);
          this.loadSaleSubmissions(this.saleId, true);
          this.saleHorse = notification.data.saleHorse; // update row
        }
        if (notification.action === NotificationAction.Approved || notification.action === NotificationAction.Denied) { // only for vets
          this.saleHorse = notification.data.saleHorse; // update row
        }
      }
    });
    this.eventEmitter.onSaleRequested.pipe(takeUntil(this.unsubscribe$)).subscribe((notification: NotificationEvent<SaleRequestNotificationDto>) => {
      if (notification.scope.saleId === this.saleId && notification.action === NotificationAction.Requested) {
        this.loadVets(this.saleId, true);
        this.loadSaleMemberRequests(this.saleId, 0, true);
      }
    });
    this.eventEmitter.onSaleResult.pipe(takeUntil(this.unsubscribe$)).subscribe((notification: NotificationEvent<any>) => {
      if (this.saleId === notification.scope.saleId) {
        const dataArray = Array.isArray(notification.data)
          ? notification.data
          : [notification.data];

        const saleHorses = dataArray.filter(
          x => x.saleId === this.saleId
        );

        this.updateSaleHorses = saleHorses;
      }
    });
    this.saleFacade.selectStautsSaleHorse$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        if (response) {
          this.saleFacade.clearSyncedSaleHorse();
          this.salesService.getSaleHorses(this.saleId)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((saleHorses) => {
              this.saleHorses = saleHorses;
              this.allSaleHorses = saleHorses;
            });
        }
      });
    this.eventEmitter.onStudyPopupCloseEvent.pipe(takeUntil(this.unsubscribe$)).subscribe((saleId: number) => {
      if (this.saleId === saleId) {
        this.loadSaleSubmissions(saleId, true);
        this.salesService.getSaleHorses(saleId)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((saleHorses) => {
            this.saleHorses = saleHorses;
            this.allSaleHorses = saleHorses;
          });
      }
    })
    this.eventEmitter.onSaleRequestApproveEvent.pipe(takeUntil(this.unsubscribe$)).subscribe((saleId: number) => {
      if (this.saleId === saleId) {
        this.loadVets(this.saleId, true);
        this.loadSaleMemberRequests(this.saleId, 0, true);
      }
    })
    this.eventEmitter.onSaleRequestDeniedEvent.pipe(takeUntil(this.unsubscribe$)).subscribe((saleId: number) => {
      if (this.saleId === saleId) {
        this.loadVets(this.saleId, true);
        this.loadSaleMemberRequests(this.saleId, 0, true);
      }
    })
    if (this.saleId) {
      this.isSaleLoading = true;
      this.saleFacade.loadSale(this.saleId);
      this.sales$
        .pipe(
          filter((sales) => !!sales.length),
          take(1)
        )
        .subscribe((sales) => {
          this.sale = sales.find((sale) => sale.saleId === this.saleId);
          this.lotOrHipText = this.sale?.lotOrHipText;
          this.books = this.getBooks();
          this.isSaleLoading = false;
        });

      this.saleFacade.loadSaleStatuses(this.saleId);
      //this.studyFacade.loadSaleStatuses();
      this.saleStatuses$
        .pipe(
          filter((status) => !!status.length),
          take(1)
        )
        .subscribe((status) => {
          this.saleStatuses = status;
        });

      this.loadCountries();
      this.getSaleSettings(this.saleId);
      this.loadConsignors(this.saleId);
      this.loadVets(this.saleId);
      this.loadContacts(this.saleId);
      if (this.authService.IsSalesCompany()) {
        this.loadSaleMemberRequests(this.saleId, 0);
        this.loadSaleSubmissions(this.saleId);
      }

      this.saleHorse$
        .pipe(
          filter((s) => !!s),
          take(1)
        )
        .subscribe(async (saleHorse) => {
          await this.loadSaleMemberAccessData(saleHorse.horseId);
        });
    }
    this.attachEvents();
  }

  OnMemberSelection(memberIds: any) {
    this.selectedVets = memberIds.selectedVets;
  }

  OnVetContactInfoUpdate(e: any) {
    this.loadVets(this.saleId, true);
  }
  

  isDisabledEmailSmsButton(): boolean {
    if (!this.isSalesCompany) {
      return false;
    }

    if (
      this.tab === 'consignors' ||
      this.tab === 'horses' ||
      this.selectedVets.length === 0
    ) {
      return false;
    }

    return true;
  }

  isDisabledEmailSmsConsignorButton(): boolean {
    if (!this.isSalesCompany) {
      return false;
    }

    if (
      this.tab === 'vets' ||
      this.tab === 'horses' ||
      this.formDataEmailConsignors.length === 0
    ) {
      return false;
    }

    return true;
  }

  redirectToStats(sale: Sale): void {
    this.route.navigate([`statistics/sale/${sale.saleUID}`]);
  }

  openSaleEmailSmsPopup(sale: Sale) {
    const modalRef = this.modalService.open(SaleSendEmailSmsPopupComponent, {
      ariaLabelledBy: sale.saleId + 'Id',
      centered: true,
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
    });
    const selectedMemberIds = this.selectedVets.map((item) => {
      return item.userId;
    });
    modalRef.componentInstance.data = {
      sale: sale,
      memberIds: selectedMemberIds.join(),
      notificationType: NotificationType.Vet_Notification
    };
    modalRef.componentInstance.sendDataToParent.subscribe((result: any) => {      
      const data = JSON.parse(result);
      let model = data.notificationData;
      model.sale = data.sale;
      this.mailService.sendNotificationVet(model).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
        if ((response?.warnings?.length ?? 0) > 0) {            
          this.httpErrorHandlerService.ShowWarning(
            response.warnings[0],
            'Warning!'
          );
        } else {
          modalRef.close();
          this.toastService.success("Notification sent successfully!", "Success!");
        }
      }, (error: any) => {
        this.httpErrorHandlerService.ShowErrorMessage(error);
      });
    },
    (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    }      
  );
    /*
    modalRef.result.then(
      (result) => {
        const data = JSON.parse(result);
        let model = data.notificationData;
        model.sale = data.sale;
        this.mailService.sendNotificationVet(model).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
          if ((response?.warnings?.length ?? 0) > 0) {
            this.httpErrorHandlerService.ShowWarning(
              response.warnings[0],
              'Warning!'
            );
          } else {
            this.toastService.success("Notification sent successfully!", "Success!");
          }
        }, (error: any) => {
          this.httpErrorHandlerService.ShowErrorMessage(error);
        });
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );*/
  }

  loadCountries() {
    this.commonService.getCountries().subscribe((response) => {
      if (response.body) {
        const responseData = JSON.parse(JSON.stringify(response.body));
        if (responseData) {
          this.allCountries = responseData;          
        }
      }
    });
  }
  openEmailConsignorsPopup(sale: Sale) {


    const modalRef = this.modalService.open(SaleSendEmailSmsPopupComponent, {
      ariaLabelledBy: sale.saleId + 'Id',
      centered: true,
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
    });
    const consignorIds = this.formDataEmailConsignors.map((item) => {
      return item.consignorId;
    });
    modalRef.componentInstance.data = {
      sale: sale,
      memberIds: consignorIds.join(),
      notificationType: NotificationType.Consignor_Notification
    };

    modalRef.componentInstance.sendDataToParent.subscribe((result: any) => {      
        const data = JSON.parse(result);
        let model = data.notificationData;
        model.sale = data.sale;
        this.mailService.sendNotificationVet(model).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
          if ((response?.warnings?.length ?? 0) > 0) {            
            this.httpErrorHandlerService.ShowWarning(
              response.warnings[0],
              'Warning!'
            );
          } else {
            modalRef.close();
            this.toastService.success("Notification sent successfully!", "Success!");
          }
        }, (error: any) => {
          this.httpErrorHandlerService.ShowErrorMessage(error);
        });
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }      
    );

    //const modalRef = this.modalService.open(SaleConsignorEmailPopupComponent, {
    //  ariaLabelledBy: 'EmailConsignors-Id',
    //  centered: true,
    //  size: 'md',
    //  keyboard: false,
    //  backdrop: 'static',
    //});

    //modalRef.componentInstance.data = {
    //  formDataEmailConsignors: this.formDataEmailConsignors,
    //};
    //modalRef.result.then(
    //  (result) => { },
    //  (reason) => {
    //    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //  }
    //);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public loadConsignors(saleId: number, force: boolean | null = false): void {
    if (!this.saleConsignors || force) {
      this.isLoaderSaleConsignors = true;

      this.salesService
        .getSaleConsignors(saleId)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((response) => {
          this.saleConsignors = response;
         

          this.allSalesConsignors = this.saleConsignors;
          const result = this.helper.groupBy(
            this.saleConsignors,
            'consignorId'
          );
          this.allSalesConsignorsCount = Object.keys(result).length;
          this.isLoaderSaleConsignors = false;
        });
    } 
  }

  public loadVets(saleId: number, force: boolean | null = false): void {
    if (!this.saleVets || force) {
      this.isLoaderSaleVets = true;

      this.salesService
        .getSaleVets(saleId)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((response) => {
          this.saleVets = response;

          this.saleVets = this.saleVets.map((obj) => {
            obj.checkbox = false;
            return obj;
          });

          this.allSalesVets = this.saleVets;
          this.salesVetsCount = this.allSalesVets?.length;
          this.isLoaderSaleVets = false;
        });
    }
  }

  public loadContacts(saleId: number, force: boolean | null = false): void {
    if (this.isSalesCompany) {
      if (!this.saleVets || force) {
        this.salesService
          .getRepoContactBySaleId(saleId)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((response) => {
            this.contacts = response;
            this.contactsCount = this.contacts?.length;
          });
      }
    }
  }
  public AddNewContact() {
    var contact = { repoContactId:0 } as SaleHorseRepoContactDto;
    this.openContactPopup(contact);
  }
  public onContactEdit(contact: SaleHorseRepoContactDto) {
    this.repoBusinessService.getContactById(contact.repoContactId).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      const saleHorseContact = { ...response } as SaleHorseRepoContactDto;
      saleHorseContact.contactDownloadLink = contact.contactDownloadLink;
      this.openContactPopup(saleHorseContact);
    });
  }
  private openContactPopup(contact: SaleHorseRepoContactDto) {
    const modalRef = this.modalService.open(SaleHorseRepoContactEditComponent, {
      ariaLabelledBy: this.saleId + 'Id',
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
    });
    
    modalRef.componentInstance.contact = contact;
    modalRef.componentInstance.link = this.appendShareLinkPrefix(contact.contactDownloadLink);
    modalRef.componentInstance.allSaleHorses = this.saleHorses;
    modalRef.componentInstance.saleId = this.saleId;
    modalRef.result.then(
      (result) => {
        const data = JSON.parse(result);
        this.loadContacts(this.saleId, true);
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  public deleteContact(contact: SaleHorseRepoContactDto) {

    Swal.fire({
      title: 'Remove Contact',
      html: `Are you sure you want to remove the contact from sale? This is an irreversible action.`,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Delete',
      confirmButtonColor: '#1b6da6',
    }).then((result) => {
      if (result.isConfirmed) {
        this.salesService
          .deleteSaleHorseRepoContacts(this.saleId, contact.repoContactId)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((response) => {
            this.toastService.success('Contact Removed!', 'Success');
            this.loadContacts(this.saleId, true);
          }, (err) => this.httpErrorHandlerService.ShowErrorMessage(err));
      }
    });
  }
  public appendShareLinkPrefix(linkPostfix: string) {
    return `${window.location.origin}/${linkPostfix}`;
  }

  public loadSaleMemberRequests(
    saleId: number,
    saleMemberStatusId: number,
    force: boolean | null = false
  ): void {
    if (!this.saleMemberRequests || force) {
      this.isLoaderSaleMemberRequest = true;
      this.salesService
        .getSaleMemberRequests(saleId, saleMemberStatusId)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((response) => {
          this.saleMemberRequests = response;
          this.allSaleMemberRequests = this.saleMemberRequests;

          const requestedCounts = this.saleMemberRequests.filter(
            (x) => x.saleMemberStatusId == SaleMembersStatusIds.REQUESTED
          );
          if (requestedCounts?.length) {
            this.saleMemberRequestCount = requestedCounts.length;
          }

          this.isLoaderSaleMemberRequest = false;
        });
    }
  }

  openStudyFilePopupByHorseId(submission: any): void {
    const saleHorse = this.saleHorses.find((sh) => sh.horseId === submission.horseId);
    this.submissionId = submission.submissionId;
    this.openStudyFileModal(saleHorse);
  }
  openSaleHorseStatusModel(saleHorse: SaleHorse) {
    this.salesService.getSaleHorseResult(this.saleId, saleHorse.horseId).pipe(takeUntil(this.unsubscribe$)).subscribe((result) => {
      //this.saleHorse$.pipe(takeUntil(this.unsubscribe$)).subscribe((result) => {
      //  if (result && result.horseId && openDialog) {
      const modalRef = this.modalService.open(SaleHorseStatusModalComponent, {
        ariaLabelledBy: saleHorse.horseId + 'Id',
        size: 'md',
        centered: true,
        keyboard: false,
        backdrop: 'static',
      });

      modalRef.componentInstance.data = {
        sale: this.sale,
        horse: JSON.parse(JSON.stringify(result)),
        saleStatuses: this.saleStatuses,
      };
      modalRef.result.then(
        (result) => {

          const sh = result as SaleHorseStatus;          
          this.saleFacade.updateSaleHorseStatus(sh);
         
        },
        (reason) => {
          //openDialog = false;
         // this.saleFacade.loadSaleHorse(this.saleId, saleHorse.horseId);
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
      //  }
    })
  }
  openStudyFileModal(saleHorse: SaleHorse): void {
    this.studyFacade.resetData();
    this.studyFacade.loadStudyFilesBySaleHorse(saleHorse);

    this.studyFacade.loadStatuses();
    const modalRef = this.modalService.open(SaleStudyFilesPopupComponent, {
      ariaLabelledBy: saleHorse.horseId + 'Id',
      centered: true,
      // A fixed 1040px measure — see .modal-study-files in styles.scss. It was
      // full-width + fullscreen, which is what left the file lists spread across
      // the whole monitor.
      size: 'study-files',
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.componentInstance.data = {
      saleId: this.sale.saleId,
      horseId: saleHorse.horseId,
      statusId: saleHorse.submissionStatusId,
    };
    modalRef.result.then(
      (result) => { },
      (reason) => {
        if (reason) {
          this.loadSaleSubmissions(this.saleId, true)
          this.salesService.getSaleHorses(this.saleId)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((saleHorses) => {
              this.saleHorses = saleHorses;
              this.allSaleHorses = saleHorses;
            });
        }
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  
  public loadSaleSubmissions(
    saleId: number,
    force: boolean | null = false
  ): void {
    if (!this.saleMemberRequests || force) {
      this.isLoaderSaleMemberRequest = true;
      this.salesService
        .getSaleSubmissions(saleId)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((response) => {

          this.saleSubmissions = response;
          this.allSaleSubmissions = this.saleSubmissions;
          this.updateSaleSubmissionCounts();

          this.isLoaderSaleSubmissions = false;
        });
    }
  }

  public onNewSaleSubmissions(newSubmissions: SaleSubmissions[]): void {
    if (!this.saleSubmissions) {
      this.saleSubmissions = [];
    }

    let updated = [...this.saleSubmissions];

    newSubmissions.forEach((newSubmission) => {
      const index = updated.findIndex(x => x.id === newSubmission.id);

      if (index === -1) {
        updated.unshift(newSubmission);
      } else {
        updated[index] = newSubmission;
      }
    });

    // NEW reference → Input setter WILL fire
    this.saleSubmissions = updated;

    this.allSaleSubmissions = [...updated];
    this.updateSaleSubmissionCounts();
  }


  private updateSaleSubmissionCounts(): void {
    const inReviewSubmissions = this.saleSubmissions.filter(
      x => x.statusId === SaleSubmissionsStatusIds.IN_REVIEW
    );

    if (inReviewSubmissions.length) {
      const horseCount = new Set(
        inReviewSubmissions.map(x => x.lot)
      ).size;

      this.saleSubmissionsCount =
        `${inReviewSubmissions.length}/${horseCount}`;
    } else {
      this.saleSubmissionsCount = '0/0';
    }
  }


  public onApproveRequest($event: any) {
    this.loadVets(this.saleId, true);
    this.loadSaleMemberRequests(this.saleId, 0, true);
  }

  public onDeniedRequest($event: any) {
    this.loadVets(this.saleId, true);
    this.loadSaleMemberRequests(this.saleId, 0, true);
  }

  public approveDeniedSubmissionsEvent($event: {
    response: boolean;
    type: string;
  }): void {
    this.loadSaleSubmissions(this.saleId, true);
  }

  public onClickTab(tab: string) {
    this.tab = tab;
    //this.formDataEmailConsignors = [];
    //this.selectedVets = '';

    if ('consignors' === this.tab) {
      this.loadConsignors(this.saleId);
    }

    if ('vets' === this.tab) {
      this.loadVets(this.saleId);
    }
    if ('horses' === this.tab) {
      // this.saleFacade.loadSaleHorses(this.saleId);
    }

    if ('requests' === this.tab) {
      this.loadSaleMemberRequests(this.saleId, 0);
    }

    if ('submissions' === this.tab) {
      this.loadSaleSubmissions(this.saleId);
    }
    if ('contacts' === this.tab) {
      this.loadContacts(this.saleId);
    }
  }

  onCheckedSaleConsignorsEvent($event: { formDataEmailConsignors: [] }) {
    if ($event) {
      this.formDataEmailConsignors = $event.formDataEmailConsignors;
    }
  }
  onConsignorContactSaveEvent() {    
    this.loadConsignors(this.saleId, true);
  }

  private attachEvents() {
    this.saleProfileError$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        if (typeof response !== 'undefined' && response !== null) {
          this.isSaleLoading = false;
          this.httpErrorHandlerService.ShowErrorMessage(response);
          this.saleFacade.resetErrorState();
          this.router.navigate(['/sales']);
        }
      });

    this.salesService.getSaleHorses(this.saleId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((saleHorses) => {
        this.saleHorses = saleHorses;
        this.allSaleHorses = saleHorses;
      });


   

    this.eventEmitter.updateStudyFileStatus
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.loadSaleSubmissions(this.saleId, true);
      });
  }
  public resetFilterForm() {
    this.filterForm = this.formBuilder.group({
      book: [''],
      session: [''],
      consignor: [''],
      sire: [''],
      dam: [''],
      vet: [''],
      xray: [''],
      scope: [''],
      report: [''],
      // Add more form controls as needed
    });
    this.searchHorses();
  }

  public searchHorses() {
    const filters = this.filterForm.value;

    let filteredSessions = this.sale.saleSessions;

    // Apply filters to saleSessions array
    if (filters.book) {
      filteredSessions = filteredSessions.filter(
        (session) => session.bookNumber === filters.book
      );
    }
    if (filters.session) {
      filteredSessions = filteredSessions.filter(
        (session) => session.sessionNumber === filters.session
      );
    }

    let minLotNumber: number;
    let maxLotNumber: number;

    // Update min and max lot numbers if there are filtered sessions
    if (filteredSessions.length > 0) {
      minLotNumber = Math.min(
        ...filteredSessions.map((session) => session.minLotNumber)
      );
      maxLotNumber = Math.max(
        ...filteredSessions.map((session) => session.maxLotNumber)
      );
    }

    // Apply filters to the saleHorses array
    this.saleHorses = this.allSaleHorses.filter((horse) => {
      // Check if any one of the book or session filters are applied

      // Check if any one of the book or session filters are applied
      const isInFilterArray = (value: string, filterArray: string[]) => {
        // Ensure the value exists and the filter array contains the value
        return (
          filterArray.length === 0 ||
          filterArray.some((filterValue) => value === filterValue.toLowerCase())
        );
      };

      // Check if the selected filter is an array and contains values
      const isFilterArray = (filterValue: any) =>
        Array.isArray(filterValue) && filterValue.length > 0;

      // Return true if no book or session filter is applied, otherwise check the specific filters
      return (
        horse.lotNumber >= minLotNumber &&
        horse.lotNumber <= maxLotNumber &&
        (!filters.consignor ||
          horse.consignor
            ?.toLowerCase()
            .includes(filters.consignor.toLowerCase())) &&
        (!filters.sire ||
          horse.sire?.toLowerCase().includes(filters.sire.toLowerCase())) &&
        (!filters.dam ||
          horse.dam?.toLowerCase().includes(filters.dam.toLowerCase())) &&
        (!filters.vet ||
          horse.submittedBy
            ?.toLowerCase()
            .includes(filters.vet.toLowerCase())) &&
        // Handle multiple selections for report
        (!isFilterArray(filters.report) ||
          isInFilterArray(
            horse.xrayReportStatus?.toLowerCase(),
            filters.report
          )) &&
        // Handle multiple selections for xray
        (!isFilterArray(filters.xray) ||
          isInFilterArray(horse.xrayStatus?.toLowerCase(), filters.xray)) &&
        (!isFilterArray(filters.status) ||
          isInFilterArray(
            horse.submissionStatus?.toLowerCase(),
            filters.status
          )) &&
        // Handle multiple selections for scope
        (!isFilterArray(filters.scope) ||
          isInFilterArray(horse.scopeStatus?.toLowerCase(), filters.scope))
      );
    });
  }

  private async loadSaleMemberAccessData(horseId: number) {
    this.saleFacade.loadSaleMemberAccess(this.saleId, horseId);
    this.saleFacade.saleMemberAccess$
      .pipe(
        filter((m) => !!m),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((memberAccessData) => {
        this.isUserSaleEditor = memberAccessData.isSalesEditor;
      });
  }

  public getBooks(): number[] {
    const bookNumbers = this.sale.saleSessions.map((s) => s.bookNumber);
    return this.getDistinctValues(bookNumbers).sort();
  }
  public filterSessions(): void {
    const form = this.filterForm.value;
    this.sessions = this.getSessions(form?.book);
  }

  private getSaleSettings(saleId: number) {
    this.salesService
      .getSaleViewerSettings(saleId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((saleSetting) => {
        this.saleSetting = saleSetting;
      });
  }

  public getSessions(book: number): number[] {
    const sessionNumbers = this.sale.saleSessions
      .filter((x) => x.bookNumber === book)
      .map((s) => s.sessionNumber);
    return this.getDistinctValues(sessionNumbers).sort();
  }

  public getConsignors(): string[] {
    const consignors = this.allSaleHorses?.map((s) => s.consignor);
    const nonEmptyValues = consignors?.filter((value) => value !== '');
    return this.getDistinctValues(nonEmptyValues).sort();
  }

  public getSires(): string[] {
    const sire = this.allSaleHorses?.map((s) => s.sire);
    const nonEmptyValues = sire?.filter((value) => value !== '');
    return this.getDistinctValues(nonEmptyValues).sort();
  }

  public getDams(): string[] {
    const dams = this.allSaleHorses?.map((s) => s.dam);
    const nonEmptyValues = dams?.filter((value) => value !== '');
    return this.getDistinctValues(nonEmptyValues).sort();
  }

  public getSubmittedVets(): string[] {
    const vets = this.allSaleHorses?.map((s) => s.submittedBy);
    const nonEmptyValues = vets?.filter((value) => value !== '');
    return this.getDistinctValues(nonEmptyValues).sort();
  }

  public getXrays(): string[] {
    const xrayStatuses = this.allSaleHorses?.map((s) => s.xrayStatus);
    const nonEmptyValues = xrayStatuses?.filter((value) => value !== '');
    return this.getDistinctValues(nonEmptyValues).sort();
  }

  public getScopes(): string[] {
    const scopeStatuses = this.allSaleHorses?.map((s) => s.scopeStatus);
    const nonEmptyValues = scopeStatuses?.filter((value) => value !== '');
    return this.getDistinctValues(nonEmptyValues).sort();
  }

  public getReports(): string[] {
    const xrayReportStatuses = this.allSaleHorses?.map(
      (s) => s.xrayReportStatus
    );
    const nonEmptyValues = xrayReportStatuses?.filter((value) => value !== '');
    return this.getDistinctValues(nonEmptyValues).sort();
  }

  private getDistinctValues<T>(values: T[]): T[] {
    return [...new Set(values)];
  }
  public ngAfterViewInit(): void {
    //fromEvent(this.searchInput.nativeElement, 'keyup')
    //  .pipe(
    //    debounceTime(50),
    //    distinctUntilChanged(),
    //    takeUntil(this.unsubscribe$),
    //    tap(() => {
    //      const term = this.searchInput.nativeElement.value;

    //      this.searchTerm = term;
    //    })
    //  )
    //  .subscribe();

    //if (this.searchTerm) {
    //  this.searchInput.nativeElement.value = this.searchTerm;
    //}
    window.setTimeout(() => {
      this.activatedRoute.queryParams.subscribe(params => {
      const activeTab = params['tab'];
      if (activeTab) {
        this.onClickTab(activeTab);
      }
    });
    }, 500);
  }
  filterData(searchText: string) {
    this.searchTerm = searchText;
  }

 
  public syncSaleHorseData(): void {
    let isLoading = false;

    // Step 1: check if sale study exists (true = show checkbox)
    this.salesService.checkSaleRelatedDataExists(this.saleId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async (studyExists: boolean) => {

        // Step 2: Prepare checkbox HTML only if study exists AND no horse has data
        let checkboxHtml = '';
        if (!studyExists && this.allSaleHorses.length > 0) {
          checkboxHtml = `
          <div style="margin-top:10px; text-align:center;">
            <input type="checkbox" id="deleteHorsesOption" />
            <label for="deleteHorsesOption" style="margin-left:6px;">
              Delete all horses and re-import
            </label>
          </div>
        `;
        }

        // Step 3: SweetAlert
        Swal.fire({
          title: 'Refresh Tw Repo Data',
          html: `
          <span>Do you want to refresh <b>${this.sale?.saleName}</b> horses data?</span>
          ${checkboxHtml}
        `,
          showCancelButton: !isLoading,
          cancelButtonText: 'Cancel',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Refresh',
          confirmButtonColor: '#1b6da6',
          showLoaderOnConfirm: false,
          allowOutsideClick: () => !isLoading,

          preConfirm: async () => {
            try {
              // User selected delete option?
              const deleteOptionChecked = (document.getElementById('deleteHorsesOption') as HTMLInputElement)?.checked;

              let response;

              if (deleteOptionChecked) {
                // Step 4A: delete + refresh
                response = await this.authService
                  .refreshTwSaleHorseDataWithDelete(this.saleId, true)
                  .toPromise();
              } else {
                // Step 4B: refresh only
                response = await this.authService
                  .refreshTwSaleHorseData(this.saleId)
                  .toPromise();
              }

              if (!response) {
                throw new Error('Response is empty');
              }

              return response;

            } catch (error: any) {
              this.httpErrorHandlerService.ShowErrorMessage(error);
              return false;
            }
          },

          willOpen: () => { isLoading = true; },
          willClose: () => { isLoading = false; }
        }).then((result) => {
          if (result.isConfirmed) {
            // Refresh horses listing
            this.salesService.getSaleHorses(this.saleId)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((saleHorses) => {
                this.saleHorses = saleHorses;
                this.allSaleHorses = saleHorses;
              });

            Swal.fire('Success', 'Data refreshed successfully', 'success');
          }
        });

      });
  }
}
